// Friendly messages for backend ErrorCode values not already self-explanatory.
const ERROR_CODE_MESSAGES = {
  ATTENDANCE_ALREADY_EXISTS: "Attendance has already been marked.",
  ATTENDANCE_NOT_FOUND: "Attendance record was not found.",
  ATTENDANCE_CORRECTION_NOT_FOUND: "Attendance correction request was not found.",
  ATTENDANCE_CORRECTION_ALREADY_PENDING: "A correction request is already pending.",
  ATTENDANCE_CORRECTION_NOT_APPROVED: "The correction has not been approved by an administrator.",
  ATTENDANCE_CORRECTION_ALREADY_COMPLETED: "This correction has already been completed.",
  STUDENT_NOT_FOUND: "Student was not found.",
  CLASS_NOT_FOUND: "Class was not found.",
  FORBIDDEN: "You do not have permission to perform this action.",
  FEATURE_DISABLED: "This feature is not enabled for your school.",
  VALIDATION_FAILED: "Please check the entered information.",
};

export const getApiErrorCode = (err) => err?.response?.data?.errorCode;

export const resolveApiErrorMessage = (err, fallbackMessage) => {
  const errorCode = getApiErrorCode(err);
  if (errorCode && ERROR_CODE_MESSAGES[errorCode]) return ERROR_CODE_MESSAGES[errorCode];
  return err?.message || fallbackMessage;
};

export default resolveApiErrorMessage;
